import React, {useEffect, useState} from 'react';
import ActionModal from "./ActionModal";
import {toast} from "react-toastify";
import {Col, Container, FormControl, FormLabel, Row} from "react-bootstrap";
import IconButton from "../../IconButton";
import {faPlus, faTrashCan} from "@fortawesome/free-solid-svg-icons";
import LoadingSpinner from "../../Loading/LoadingSpinner";
import messageFromError from "../../../utils/errorUtils";
import useCompanyId from "../../../Hooks/useCompanyId";
import {useTranslation} from "react-i18next";

const ManageExtrasModal = ({active, keys, onCancel, onDelete, onCreate, onUpdate,
                                  updateExtraKeys, addExtraKey, deleteExtraKey }) => {

    const maxKeys = 3;
    const companyId = useCompanyId()

    const [extraToDelete, setExtraToDelete] = useState(null);

    const [mutableKeyMap, setMutableKeyMap] = useState(keys)
    const [newKey, setNewKey] = useState('')
    const [newKeyIsLoading, setNewKeyIsLoading] = useState(false)

    const {t} = useTranslation()

    useEffect(() => {
        setMutableKeyMap(keys)
    }, [keys]);


    async function updateExtras()
    {
        try {
            await updateExtraKeys(mutableKeyMap, companyId)
            onUpdate()
        }
        catch(ex)
        {
            toast.error(messageFromError(ex))
        }
    }

    async function addKey()
    {
        try {
            setNewKeyIsLoading(true)
            await addExtraKey({ key: newKey.trim() }, companyId)
            toast.success(`Added ${newKey}`)
            setNewKey('')
            onCreate()
        }
        catch (ex)
        {
            toast.error(messageFromError(ex))
        }
        finally {
            setNewKeyIsLoading(false)
        }
    }

    async function deleteExtra()
    {
        await deleteExtraKey(extraToDelete, companyId)
        onDelete()
    }

    return (
        <>
            <ActionModal
                func={updateExtras}
                active={active}
                hideOnConfirm
                onCancel={onCancel}
                onConfirm={() => {
                    toast.success("Updated");
                }}
                title={t('dialogs.manageExtraKeysDialog.title')}
                positiveButton={{
                    text: t('global.operations.update'),
                    variant: 'success',
                    disabled: mutableKeyMap.some(msisdnKey => msisdnKey.key.length < 1)
                }}>

                <Container>
                    <FormLabel>{t('dialogs.manageExtraKeysDialog.existingKeys')}</FormLabel>
                    {mutableKeyMap.length > 0 ? mutableKeyMap.map((msisdnKey, i) => {
                            return (
                                <Row className='mb-2' key={i}>
                                    <Col>
                                        <FormControl type='text' value={msisdnKey.key} onChange={e => {
                                            setMutableKeyMap(prev => prev.map((item, index) => {
                                                    if (index === i) {
                                                        return {...item, key: e.target.value};
                                                    }
                                                    return item;
                                                })
                                            )
                                        }}/>
                                    </Col>
                                    <Col sm={1} className='center'>
                                        <IconButton icon={faTrashCan} color='red' onClick={() => setExtraToDelete(msisdnKey.key)}/>
                                    </Col>
                                </Row>
                            )
                        })
                        :
                        <Row>
                            <Col>
                                <span>{t('dialogs.manageExtraKeysDialog.noExistingKeys')}</span>
                            </Col>
                        </Row>}
                    {mutableKeyMap.length < maxKeys &&
                        <>
                            <Row  className='mt-4'>
                                <Col>
                                    <hr className='mt-2'/>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <FormLabel>{t('dialogs.manageExtraKeysDialog.addNewKeyTitle')}</FormLabel>
                                </Col>
                            </Row>
                            {
                                newKeyIsLoading ? <Row><Col><LoadingSpinner variant='success'/></Col></Row>
                                    :
                                    <Row className='align-items-center'>
                                        <Col>
                                            <FormControl type='text' placeholder={t('dialogs.manageExtraKeysDialog.addNewKeyPlaceholder')} value={newKey} onChange={e => setNewKey(e.target.value)}/>
                                        </Col>
                                        <Col sm={1} className='center'>
                                            <IconButton icon={faPlus} disabled={newKey.trim().length < 1} color="white" bg="#198754" onClick={addKey}/>
                                        </Col>
                                    </Row>
                            }

                        </>}
                </Container>
            </ActionModal>

            <ActionModal
                active= {extraToDelete}
                func={deleteExtra}
                onCancel= {() => setExtraToDelete(null)}
                onConfirm={() => setExtraToDelete(null)}
                title={t('dialogs.confirmDeleteDialog.title')}
                positiveButton= {
                    {text: t('global.operations.delete'), variant: "danger"}
                }
                showSpinner>
                <span>{t('pages.workers.deleteDialog.messageP1')} <strong style={{color: 'red'}}>{t('dialogs.manageExtraKeysDialog.delete')} </strong>{t('dialogs.manageExtraKeysDialog.theKey')} <strong>{extraToDelete}</strong><br/> <strong style={{color: 'black'}}>{t('dialogs.manageExtraKeysDialog.actionWarning')}</strong> <br/>{t('dialogs.manageExtraKeysDialog.areYouSure')} </span>
            </ActionModal>
        </>
    );
};

ManageExtrasModal.defaultProps = {
    keys: [],
    onCancel: () => {},
    onDelete: () => {},
    onCreate: () => {},
    onUpdate: () => {}
}

export default ManageExtrasModal;